module.exports = __webpack_public_path__ + "img/BEFIRST_movie_04.8f50772f.png";